import { ASPENDENTAL_FONTS, MOTTO_FONTS, MOTTO_V2_FONTS, WELLNOW_FONTS } from './constant';
var aspendental = ASPENDENTAL_FONTS;
var motto = MOTTO_FONTS;
var mottoV2 = MOTTO_V2_FONTS;
var wellnow = WELLNOW_FONTS;
export { wellnow, aspendental, motto, mottoV2 };